// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"kE-z","smallCardRow":"lE-z","largeCardRow":"mE-z","productSearchRow":"nE-z","curatedRow":"oE-z"};